<template>
  <section class="page-admin-form">
    <breadcrumbs :items="breadcrumbs" />

    <div class="content">
      <rp-admin-form
        @submit="updateUser"
        :genders="genders"
        :statuses="statuses"
        :roles="roles"
        v-model="form"/>

      <rp-overlay :active="active">
        <rp-alert
          icon="done"
          :message="successMessage"
          :onClick="successFunction" />
      </rp-overlay>
    </div>
  </section>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs'
  import AdminForm from 'raypro_ui/src/components/ui/forms/Admin'
  import {updateUser, getAvailableRoles, getUser, deactivateUser, activateUser} from 'raypro_ui/src/api/users'
  import Overlay from 'raypro_ui/src/components/ui/Overlay'
  import Alert from 'raypro_ui/src/components/ui/Alert'
  import page from '@/mixins/page'

  export default {
    data() {
      return {
        errors: {},
        form: {},
        roles: [],
        genders: [
          {'label': 'Male', 'value': 'M'},
          {'label': 'Female', 'value': 'F'},
          {'label': 'Prefer not to say', 'value': 'O'}
        ],
        status: '',
        statuses: [
          {label: 'Active', 'value': 'active'},
          {label: 'Inactive', 'value': 'inactive'}
        ],
        active: false,
        successMessage: 'Admin updated successfully!',
        title: 'Edit Admin',
        breadcrumbs: [
          {
            label: 'Admins',
            link: 'all-users',
            params: {role: 'Raypro_admin'}
          },
          {label: 'Edit Admin'}
        ]
      }
    },

    mixins: [page],

    mounted() {
      this.getRoles()
      this.getUser()
    },

    computed: {
      adminPayload() {
        const form = this.form

        return {
          user: {
            email: form.email,
            user_roles: [{role_id: form.role}],
            status: form.status,
            profile: {
              first_name: form.first_name,
              last_name: form.last_name,
              gender: form.gender
            }
          }
        }
      }
    },

    props: {id: String},

    components: {
      'rp-admin-form': AdminForm,
      'rp-overlay': Overlay,
      'rp-alert': Alert,
      Breadcrumbs
    },

    methods: {
      successFunction() {
        this.$router.push({name: 'all-users', params: {role: 'raypro_admin'}})
      },

      getRoles() {
        getAvailableRoles().then(({data}) => {
          this.roles = data.available_roles.map((role) => {
            return {key: role.name, value: role.id}
          })
        })
      },

      getUser() {
        getUser(this.id).then(({data}) => {
          this.status = data.activated_at ? 'active' : 'inactive'

          this.form = {
            email: data.email,
            role: data.roles[0].id,
            first_name: data.profile.first_name,
            last_name: data.profile.last_name,
            gender: data.profile.gender,
            status: data.activated_at ? 'active' : 'inactive'
          }
        })
      },

      updateUser() {
        const formStatus = this.adminPayload.user.status

        if(formStatus === 'active') {
          activateUser({id: this.id})
            .then(() => {
              this.activeOverlay = true
            })
            .catch(({response}) => {
              this.errors = response.errors
            })
        } else {
          deactivateUser({id: this.id})
            .then(() => {
              this.activeOverlay = true
            })
            .catch(({response}) => {
              this.errors = response.errors
            })
        }

        updateUser(this.id, this.adminPayload)
          .then(() => {
            this.active = true
          })
          .catch(({response}) => {
            this.errors = response.errors
          })
      }
    }
  }
</script>

<style lang="sass">
</style>



// WEBPACK FOOTER //
// src/components/pages/RayproAdmin/RayproAdminEdit.vue